const transactionHistoryObjects = [
  {
    status: "success",
    type: "Buy",
    item: "BTC",
    value: 0.00291,
    valueInUSD: "$230",
    date: "10 Dec ",
    time: "10:00 AM",
    id: 1,
  },

  {
    status: "success",
    type: "Transfer",
    item: "ETH",
    value: 0.02701,
    valueInUSD: "$230",
    date: "10 Dec ",
    time: "10:00 AM",
    id: 3,
  },
  {
    status: "success",
    type: "Exchange",
    item: "BTC",
    value: 0.0301,
    valueInUSD: "$230",
    date: "10 Dec ",
    time: "10:00 AM",
    id: 4,
  },
  {
    status: "completed  ",
    type: "Exchange",
    item: "ETH",
    value: 0.01,
    valueInUSD: "$230",
    date: "10 Dec ",
    time: "10:00 AM",
    id: 5,
  },

  {
    status: "in progress...",
    type: "Buy",
    item: "BTC",
    value: 0.00432,
    valueInUSD: "$20",
    date: "13 Dec ",
    time: "06:20 PM",
    id: 6,
  },
];

export default transactionHistoryObjects;
